import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import { TranslateService } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { LoaderComponent } from '../loader/loader.component';
import { AlertComponent } from '../alert/alert.component';

type FileType = 'images' | 'importContacts' | 'clientAttachments';

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
    imports: [FileUploadModule, NgClass, LoaderComponent, AlertComponent],
    standalone: true
})
export class UploadFileComponent implements OnInit {

  @Input() btnCopy = 'Upload';
  @Input() titleCopy = '';
  @Input() descriptionCopy = '';
  @Input() type: FileType = 'images';
  @Output() complete = new EventEmitter;

  private URL = 'https://image-uploader-service.firebaseapp.com/upload';
  public errorMsg;
  public success = false;

  public uploading = false;

  public allowedMimeType: string[] = [];
  public uploader: FileUploader;
  public hasBaseDropZoneOver = false;
  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    let additionalParameter;

    switch (this.type) {
      case 'importContacts':
        this.allowedMimeType = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
          'text/csv',
          'text/vcard'
        ];
        additionalParameter = {ignoreResizer: true};
        break;
      case 'clientAttachments':
        this.allowedMimeType = [
          'image/jpeg',
          'image/jpg',
          'image/png',
          'image/gif',
          'image/webp',
          'image/svg+xml',
          'image/bmp',
          'image/tiff',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'text/plain',
        ];
        additionalParameter = {ignoreResizer: true};
        break;
      default:
        this.allowedMimeType = ['image/png', 'image/jpg', 'image/jpeg'];
        additionalParameter = {};
        break;
    }

    this.uploader = new FileUploader({
      url: this.URL,
      method: 'POST',
      autoUpload: true,
      allowedMimeType: this.allowedMimeType,
      maxFileSize: 5 * 1024 * 1024, // 5 MB
      itemAlias: 'file',
      additionalParameter,
    });

    this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => {
      this.onFileUploadSuccess(item, response);
    };
    this.uploader.onBeforeUploadItem = () => {
      this.onFileUploadStart();
    };
    this.uploader.onErrorItem = () => {
      this.onFileUploadError();
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };

    this.uploader.onWhenAddingFileFailed = (_fileItem, filter) => {
      if (filter?.name === 'fileSize') {
        this.errorMsg = this.translate.instant('DASHBOARD.clientAttachments.fileTooLarge', { max: 5 });
      } else {
        this.errorMsg = this.translate.instant('GENERAL.fileTypeNotSupported');
      }
    };
  }

  get showDropArea(): boolean {
    return this.type === 'importContacts' || this.type === 'clientAttachments';
  }

  onFileUploadStart() {
    this.errorMsg = null;
    this.uploading = true;
  }

  onFileUploadSuccess(item, fileUrl) {
    const image = JSON.parse(fileUrl);
    this.complete.emit({
      url: image.data,
      fileName: item.file.name,
      fileType: item.file.type,
      fileSize: item.file.size,
    });
    this.uploader.clearQueue();
    this.uploading = false;
  }

  onFileUploadError() {
    this.errorMsg = this.translate.instant('GENERAL.generalErrorMsg');
    this.uploading = false;
  }

}
